import { isEqual } from 'lodash-es'

export function deepDiff(obj1: Record<string, any>, obj2: Record<string, any>, parentKey = ''): Record<string, any> {
  let differences: Record<string, any> = {}

  for (const key in obj1) {
    if (!(key in obj2)) {
      differences[parentKey + key] = { obj1: obj1[key], obj2: undefined }
    } else if (Array.isArray(obj1[key]) && Array.isArray(obj2[key]) && !isEqual(obj1[key], obj2[key])) {
      differences[parentKey + key] = { obj1: obj1[key], obj2: obj2[key] }
    } else if (obj1[key] !== obj2[key] && (typeof obj1[key] !== 'object' || obj1[key] === null)) {
      differences[parentKey + key] = { obj1: obj1[key], obj2: obj2[key] }
    } else if (typeof obj1[key] === 'object' && obj1[key] !== null) {
      const nestedDifferences = deepDiff(
        obj1[key] as Record<string, any>,
        obj2[key] as Record<string, any>,
        parentKey + key + '.',
      )

      differences = { ...differences, ...nestedDifferences }
    }
  }

  for (const key in obj2) {
    if (!(key in obj1)) {
      differences[parentKey + key] = { obj1: undefined, obj2: obj2[key] }
    }
  }

  return differences
}
